import { AssetType, PlaybackState, } from '@zattoo/playback-sdk';
import { StreamProvider } from './stream-provider';
import { ZapiEventKey } from '../../player/modules/event/event-key';
import { isRakutenStreamRequest, isRakutenVodRequest, isRakutenVodTrailerRequest, } from '../request/utils';
import { getPlaybackCapability } from '../../capability';
import * as utils from './utils';
export const PlayerWithVod = (Base) => {
    return class extends Base {
        #capability = null;
        #suppressStopEvent = false;
        playVod(token, teasableId, teasableType, playOptions) {
            return this.requestStream({
                playOptions,
                assetType: AssetType.VOD,
                watchRequestParams: {
                    teasable_id: teasableId,
                    teasable_type: teasableType,
                    term_token: token,
                    https_watch_urls: true,
                },
                streamProvider: StreamProvider.ZATTOO,
            });
        }
        playVodTrailer({ teasableId, teasableType, playOptions, }) {
            return this.requestStream({
                playOptions: {
                    ...playOptions,
                    drmRequired: false,
                    startupPosition: 0,
                },
                assetType: AssetType.VOD_TRAILER,
                watchRequestParams: {
                    teasable_id: teasableId,
                    teasable_type: teasableType,
                },
                streamProvider: StreamProvider.ZATTOO,
            });
        }
        async playVodRakuten({ token, teasableId, teasableType, streamingOptions, playOptions, }) {
            this.#capability = await getPlaybackCapability(StreamProvider.RAKUTEN);
            return this.requestStream({
                playOptions,
                assetType: AssetType.VOD,
                watchRequestParams: {
                    teasable_id: teasableId,
                    teasable_type: teasableType,
                    term_token: token,
                    https_watch_urls: true,
                },
                streamProvider: StreamProvider.RAKUTEN,
                streamingOptions,
            });
        }
        playVodTrailerRakuten({ teasableId, teasableType, trailerAudioLanguages, playOptions, }) {
            return this.requestStream({
                playOptions: {
                    ...playOptions,
                    drmRequired: false,
                },
                assetType: AssetType.VOD_TRAILER,
                watchRequestParams: {
                    teasable_id: teasableId,
                    teasable_type: teasableType,
                },
                audioLanguages: trailerAudioLanguages,
                streamProvider: StreamProvider.RAKUTEN,
            });
        }
        // @ts-expect-error https://github.com/microsoft/TypeScript/issues/48125
        setAudioTrack(track) {
            if (!this.zapiStreamRequestInfo ||
                !isRakutenVodRequest(this.zapiStreamRequestInfo)) {
                super.setAudioTrack(track);
                return;
            }
            const streamRequestInfo = this.zapiStreamRequestInfo;
            this.#suppressStopEvent = true;
            this.playVodRakuten({
                token: streamRequestInfo.watchRequestParams.term_token,
                teasableId: streamRequestInfo.watchRequestParams.teasable_id,
                teasableType: streamRequestInfo.watchRequestParams.teasable_type,
                streamingOptions: streamRequestInfo.streamingOptions,
                playOptions: {
                    ...streamRequestInfo.playOptions,
                    preferredAudioLanguage: track.locale,
                    startupPosition: this.currentPosition ?? 0,
                    preferredAudioFormat: track.audioFormat,
                },
            }).finally(() => {
                this.#suppressStopEvent = false;
            });
        }
        triggerFullEvent(event, options) {
            if (event.type === ZapiEventKey.WATCH_REQUESTED) {
                this.#suppressStopEvent = false;
            }
            if (this.#suppressStopEvent &&
                event.type === ZapiEventKey.PLAYBACK_STATE_CHANGED &&
                event.state === PlaybackState.STOPPED) {
                super.triggerFullEvent(event, {
                    ...options,
                    internal: true,
                });
                return;
            }
            super.triggerFullEvent(event, options);
        }
        triggerEvent(event) {
            if (!this.zapiStreamRequestInfo ||
                !isRakutenStreamRequest(this.zapiStreamRequestInfo) ||
                !this.#capability) {
                super.triggerEvent(event);
                return;
            }
            if (isRakutenVodRequest(this.zapiStreamRequestInfo) &&
                event.type === ZapiEventKey.AVAILABLE_AUDIO_TRACKS_CHANGED) {
                super.triggerEvent(utils.processAvailableAudioTracksRakutenVod(event, this.zapiStreamRequestInfo, this.#capability));
                return;
            }
            if (isRakutenVodTrailerRequest(this.zapiStreamRequestInfo) &&
                event.type === ZapiEventKey.AVAILABLE_AUDIO_TRACKS_CHANGED) {
                super.triggerEvent(utils.processAvailableAudioTracksRakutenVodTrailer(event, this.zapiStreamRequestInfo));
                return;
            }
            if (event.type === ZapiEventKey.SELECTED_AUDIO_TRACK_CHANGED) {
                super.triggerEvent(utils.processSelectedAudioTrackRakutenVod(event, this.zapiStreamRequestInfo));
                return;
            }
            super.triggerEvent(event);
        }
    };
};
